import React from "../../__compat__/react/main.entry.mjs.mjs";
import { Notification } from "../index.mjs.mjs";
import { StyledNotificationList } from "./NotificationList.styles.mjs.mjs";
const getNotifications = (notifications) => notifications.map((item) => (React.createElement("li", { key: item.id },
    React.createElement(Notification, { ...item }))));
export const NotificationList = ({ notifications, ariaLabel, }) => {
    return (React.createElement(StyledNotificationList, { role: "region", "aria-live": "polite", "aria-label": ariaLabel }, getNotifications(notifications)));
};
//# sourceMappingURL=NotificationList.mjs.mjs.map